<ng-container *transloco="let t; prefix: scope">
  <rma-navigation-header [showBackLink]="false" />
  <mat-card class="mx-auto h-full w-full max-w-3xl px-4 py-6 md:mb-4 md:mt-14 md:h-auto md:p-10">
    <mat-card-header>
      <h3 class="text-heading-3">{{ t('title') }}</h3>
    </mat-card-header>

    <img
      alt=""
      role="presentation"
      class="mx-auto mb-6 mt-4"
      [src]="'dashboard/illustrations/offer-alt-sub-img.png' | staticImageUrl"
      width="300"
    />

    <mat-card-content>
      <div class="flex flex-col gap-3 rounded border border-steel-20 p-5">
        <p>{{ t('subheading') }}</p>
        <ul>
          @for (keySuffix of [1, 2, 3, 4]; track keySuffix) {
            <li class="flex gap-2 py-1">
              <rma-icon class="text-blue-50" glyph="done" />
              <p>{{ t('featureBenefit' + keySuffix) }}</p>
            </li>
          }
        </ul>
        <p class="font-bold">{{ t('cost') }}</p>

        <ng-container *rmaLet="displayCallout$ as displayCallout">
          @if (!displayCallout) {
            <button
              type="button"
              class="mx-auto"
              [rmaLoadingIndicator]="loading$ | async"
              (click)="onInterestedClick()"
              mat-stroked-button
              color="primary"
            >
              {{ t('interested') }}
            </button>
          }

          @if (displayCallout === true) {
            <rma-callout [title]="t('successTitle')" theme="success">
              <p>{{ t('successSubtitle') }}</p>
            </rma-callout>
          }
        </ng-container>
      </div>
    </mat-card-content>
    <mat-card-actions class="flex justify-between">
      <a routerLink="/manage-account/billing" mat-button color="primary">{{ t('cancel') }}</a>
      <a mat-flat-button color="primary" routerLink="/billing/unsubscribe-confirm">
        <span>{{ t('submit') }}</span>
      </a>
    </mat-card-actions>
  </mat-card>
</ng-container>
